import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "antd";
import { useAuth } from "../../../context/AuthContext";
import useSet from "../../../hooks/common/useSet";
import { API_WALLET_DEPOSIT_CONFIRM } from "../../../utils/apis";
import toast from "react-hot-toast";
import styled from "styled-components";
import { Create } from "@mui/icons-material";
import { formatCurrency } from "../../../utils/helpers";
import { useToasts } from "../../../hooks/common/useToasts";

const WalletDepositConfirm = () => {
  const { error, uploadData, success, submitting } = useSet();
  const navigate = useNavigate();
  const { tranToken, userNumber } = useAuth();
  const location = useLocation();
  const transferData = location.state?.data?.data || {};

  const onSubmit = (e) => {
    e.preventDefault();

    uploadData({
      api: API_WALLET_DEPOSIT_CONFIRM,
      params: {
        ...transferData,
        tran_token: tranToken,
        user_no: userNumber,
        customer_mobile: transferData.customer_no,
        transaction_id: transferData.transaction_id,
      },
      method: "POST",
    });
  };

  useEffect(() => {
    if (success) {
      toast.success("Wallet topup successful");
      navigate("/register/wallet_transfers");
    }
  }, [success, navigate]);

  useToasts({
    success,
    error,
    redirect: "reload",
    successMessage: "Operation Successfull",
  });

  return (
    <form onSubmit={onSubmit}>
      <Wrapper className="flexColumn gap20">
        <TitleWrapper className="flexNullCenter gap10 x100 whiteBg radius10">
          <Create fontSize="small" color="primary" />
          <p
            className="capitalize"
            style={{
              fontWeight: "bold",
              marginBottom: 0,
            }}
          >
            Confirm Wallet TopUp
          </p>
        </TitleWrapper>

        <div className="flexColumn whiteBg p-3 radius10 gap10">
          <div className="capitalize bold pb-1 flexNullCenter mainColor">
            You are about to deposit {formatCurrency(transferData.amount)} to
            your OnePayX Wallet
          </div>
          <div>
            <label>Mobile Money Number</label>
            <p className="font12">{transferData.customer_no || "N/A"}</p>
          </div>
          <div>
            <label>Transaction ID</label>
            <p className="font12">{transferData.transaction_id || "N/A"}</p>
          </div>
        </div>

        <ButtonWrapper>
          <Button
            type="primary"
            htmlType="submit"
            disabled={submitting}
            loading={submitting}
          >
            Confirm
          </Button>
        </ButtonWrapper>
      </Wrapper>
    </form>
  );
};

export default WalletDepositConfirm;

const Wrapper = styled.div`
  padding: 0 20px 20px 20px;
  @media (max-width: 960px) {
  }
`;

const TitleWrapper = styled.div`
  padding: 10px;
  @media (max-width: 960px) {
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;
